import React from "react";
import { Container } from "./styled/menu-header";
function MenuHeader(_a) {
    var children = _a.children;
    return React.createElement(Container, { "aria-hidden": "true" }, children);
}
export default MenuHeader;
